import keyMirror from 'keymirror'

const Actions = keyMirror({

    SAVE_STATE: null,
    LOAD_STATE: null,

    SET_NAME: null,
    SELECT_CATEGORY: null,
    DESELECT_CATEGORY: null,

    UPDATE_FIELD: null,
    START_CARGO_EDITING: null,
    STOP_CARGO_EDITING: null,
    CANCEL_CARGO_EDITING: null,
    UPDATE_EDITING_CARGO: null,
    UPDATE_EDITING_CARGO_ID: null,
    UPDATE_PARAMETER: null,
    UPDATE_PARAMETER_PRICE: null,

    ADD_SUBCATEGORY: null,
    ADD_CARGO: null,
    GENERATE_CARGO: null,
    REMOVE_CARGO: null,
    UPDATE_DELIVERY_CARGO: null,
    ADD_DELIVERY_CARGO: null,
    REMOVE_DELIVERY_CARGO: null,
    SET_ATTRIBUTE_ERROR: null,
    SET_LOCATION_ERROR: null,
    SET_USER_ERROR: null,

    CARGO_COMPLETE: null,

    SET_STAGE: null,

    UPDATE_USER: null,
    UPDATE_LOCATIONS: null,
    UPDATE_DATES: null,
    UPDATE_TIME: null,

    SHOW_LOADING_OVERLAY: null,
    HIDE_LOADING_OVERLAY: null,
    UPDATE_TMP: null,

    SUBMIT: null,

    VALIDATE_CARGO: null,
    SET_VALID_TOKEN: null,
    SET_AUTOLOGIN_HASH: null,

    SEND_ATTRIBUTES_TO_GA: null,
    SEND_PARAMETERS_TO_GA: null,
    SEND_ROUTES_TO_GA: null,
    SEND_DATES_TO_GA: null,
    SEND_USER_TO_GA: null,
    CANCEL_TANKMEN_VALIDATION: null,
    ENABLE_TANKMEN_VALIDATION: null,

    OPEN_WAYPOINT_YANDEX_MAP: null,
    CLOSE_WAYPOINT_YANDEX_MAP: null,
    USE_WAYPOINT_YANDEX_MAP: null,

    UPDATE_SHOWTIPS: null,

    SET_VV_AUTHORIZATION_STATUS: null,
    DENORMALIZE_STATE: null,
    SET_MODE: null,
    SET_ORDER_ID: null,
    SET_CARRIER_ID: null,
    SET_PEREVEZI_MODE_ON: null,
    SET_B2B: null,
    SET_CLICKID: null,
    SHOW_APPROXIMATE_UNITS_WARNING: null,
    HIDE_APPROXIMATE_UNITS_WARNING: null,
    SET_WIDGET_MODE_ON: null,
    SET_ISRAEL_MODE_ON: null,
    SET_DEFAULT_COUNTRY: null,

    CHANGE_TOTAL_MEASUREMENTS: null,
    SET_TOTAL_MEASUREMENTS: null,
    SET_USER_BALANCE: null,

    SET_CALENDAR_TYPE: null,
    SET_INSTANT_BOOKING_PRICE: null,
    SET_TIME_IS_SELECTED: null,
    CALCULATE_INSTANT_BOOKING_PRICE: null,
    SET_INSTANT_PRICES: null,
    SET_INSTANT_BOOKING_SERVICES: null,
    SHOW_INSTANT_BOOKING_BY_QUERY_PARAM: null,
    HIDE_INSTANT_BOOKING_BY_QUERY_PARAM: null,
    SET_INSTANT_PRICE_DISTANCE: null,
    SET_INSTANT_PRICE_GOOGLE_MAPS_ROUTE: null,
    BLOCK_INSTANT_BOOKING_SPINNER: null,
    SELECT_INSTANT_BOOKING_PART_DAY: null,
    COMPLETE_INSTANT_BOOKING_EMAIL: null,
    SET_INSTANT_BOOKING_HASH: null,
    INSTANT_BOOKING_HASH_LOG_MODE_ON: null,
    SHOW_INSTANT_BOOKING_BY_NORMALIZED_ROUTE: null,
    TOGGLE_INSTANT_BOOKING_LOADERS: null,
    SET_INSTANT_BOOKING_DEBUG_DATA: null,
    HIDE_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON: null,
    SHOW_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON: null,
    SHOW_INSTANT_BOOKING_AWAY_MODAL: null,
    HIDE_INSTANT_BOOKING_AWAY_MODAL: null,
    SET_INSTANT_BOOKING_PROMOCODE: null,
    SET_INSTANT_BOOKING_LOADERS_SAVED: null,
    SET_LOADERS_EXPANDED: null,
})

export default Actions



// WEBPACK FOOTER //
// ./client/constants/Actions.js